import gql from 'graphql-tag';

// export const getPayments = gql`
//   query getPayments {
//     payments {
//       periodDescription
//       discountPayment
//       requestBenefit
//       summary {
//         totalAmount
//         totalRecharge
//         totalInstallmentsToPaid
//       }
//       items {
//         itemNumber
//         isPending
//         name
//         status
//         paymentStatus
//         dueDate
//         hasDiscount
//         amountProg
//         amount
//         recharge
//         periodDesc
//         paymentType {
//           id
//           desc
//         }
//         discount
//         billName
//       }
//       itemsOthers {
//         itemNumber
//         isPending
//         name
//         status
//         paymentStatus
//         dueDate
//         hasDiscount
//         amountProg
//         amount
//         recharge
//         periodDesc
//         paymentType {
//           id
//           desc
//         }
//         discount
//         billName
//       }
//     }
//     student {
//       benefit(instalments: 0) {
//         percent
//         startDate
//         endDate
//         amountWithoutBenefit
//         amountBenefit
//         amountWithBenefit
//         previousPayment
//         totalAmount
//         title
//         description1
//         description2
//       }
//     }
//   }
// `;

export const getPaymentBanks = gql`
  query getPaymentBanks {
    paymentBank {
      name
      description
      logoUrl
      appIosUrl
      appAndroidUrl
      appWebUrl
      discount
      agentCode
      locationOfChannelsUrl
    }
    utpDiscount
  }
`;

export const getPendingPayments = gql`
  query getPendingPayments {
    pendingPayments {
      items {
        name
        periodDesc
        itemNumber
        amount
        amountWithBenefits
        amountToPay
        status
        hasDiscountProntoPago
        paymentType {
          id
          desc
        }
        dueDate
        billName
        recharge
        discountProntoPago
        discountCicloCompleto
        discountBene
        dateCreate
        exonerationDatePSE
      }
      summary {
        totalPendingAmount
        totalRecharge
        totalInstallmentsToPaid
      }
    }
  }
`;

export const getPaidPayments = gql`
  query paidPayments($period: String!) {
    paidPayments(period: $period) {
      items {
        name
        amount
        amountWithBenefits
        amountToPay
        dueDate
        billName
        billingDate
        hasDiscountProntoPago
        itemNumber
        paymentType {
          id
          desc
        }
        periodDesc
        recharge
        status
        discountProntoPago
        discountCicloCompleto
        discountBene
        dateCreate
        datePayment
      }
    }
  }
`;

export const getBenefitInstallments = gql`
  query getBenefitInstallments {
    requestBenefit {
      requestBenefit
      discountPayment
      title
      description
      startDate
      endDate
    }
  }
`;

export const getBenefitInstallmentsInfo = gql`
  query getBenefitInstallmentsInfo {
    benefitInstallmentsInfo {
      startDate
      endDate
      totalInstallments
      totalAmount
      totalDiscount
      amountWithBenefit
      validationError {
        title
        description
      }
    }
  }
`;

export const activateBenefitInstallments = gql`
  mutation activateBenefitInstallments($isActivate: Boolean!) {
    activateBenefitInstallments(isActivate: $isActivate) {
      success
      validationError {
        title
        description
      }
    }
  }
`;

export const getPaymentVouchers = gql`
  query GetPaymentVouchers($itemNbr: String!) {
    paymentVouchers(itemNbr: $itemNbr) {
      voucherType
      invoiceId
      itemNumber
      internalSeries
      dteFolio
      companyRut
      dteDate
      amount
      businessUnit
    }
  }
`;

export const generatePayroll = gql`
  query GeneratePayroll(
    $companyID: String!
    $documentNumber: String!
    $documentType: String!
    $internalSeries: String!
    $documentDate: String!
    $totalAmount: String!
  ) {
    generatePayrollPDF(
      companyID: $companyID
      documentNumber: $documentNumber
      documentType: $documentType
      internalSeries: $internalSeries
      documentDate: $documentDate
      totalAmount: $totalAmount
    ) {
      fileName
      base64PDF
    }
  }
`;

export const getPaymentPeriods = gql`
  query getPaymentPeriods {
    paymentPeriods {
      ciclolectivops
      descr
    }
  }
`;
export const getPaymentsByPeriod = gql`
  query getPaymentsByPeriod($period: String!) {
    paymentsByPeriod(period: $period) {
      name
      amount
      amountWithBenefits
      amountToPay
      dueDate
      billName
      billingDate
      hasDiscountProntoPago
      itemNumber
      paymentType {
        id
        desc
      }
      periodDesc
      recharge
      status
      discountProntoPago
      discountCicloCompleto
      discountBene
      voucherType
      ruc
      series
      folio
      dateCreate
      datePayment
    }
  }
`;
